// extracted by mini-css-extract-plugin
export default {"tasks":"lM-z","task":"mM-z","svg":"nM-z","text":"oM-z"};